import React from 'react';
import { CircularProgress } from '@mui/material';

export default function Spinner({ size = 24, ...rest }) {
  return <CircularProgress size={size} {...rest} />;
}
